import { InstantAnswersConfig as IInstantAnswersConfig } from 'services/api-service'

export class InstantAnswersConfig implements IInstantAnswersConfig {
  constructor(config: IInstantAnswersConfig) {
    this.initialPageSize = config.initialPageSize
    this.pageSize = config.pageSize
    this.learnMoreEnabled = config.learnMoreEnabled
    this.multiItemQuestionEnabled = config.multiItemQuestionEnabled
    this.widgetDivId = config.widgetDivId
  }
  initialPageSize: number
  pageSize: number
  learnMoreEnabled: boolean
  multiItemQuestionEnabled: boolean
  widgetDivId: string
}

let defaultConfig: IInstantAnswersConfig = {}
export function loadConfig(config: IInstantAnswersConfig) {
  defaultConfig = new InstantAnswersConfig(config)
}
export { defaultConfig as default }



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/widgets/instant-answers/instant-answers.config.ts